jQuery(document).ready(function($) {
    
	$('.header__nav-button button').click(function(e) {
		e.preventDefault();
		$(this).toggleClass('active');
		$('#header__nav').stop().toggleClass('active');
	});
 
});
